import { request } from '@mairistem/tools';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import type ProfilEcritureFrequent from '../../../interfaces/pieces/mouvements/profilEcritureFrequent';

export const getProfilsEcritureFrequent = (params: URLSearchParams) => {
  const url = '/api/finances/comptabilite/piecescomptables/profilEcritureFrequent?';
  return request.get<unknown, TemplateRequestGet<ProfilEcritureFrequent>>(`${url}${params.toString()}`);
};

export default getProfilsEcritureFrequent;
